import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader } from "@/components/AdminLayout";
import { ReconTable } from "@/components/ReconTable";
import { LabelDialog } from "@/components/LabelDialog";
import { api, errMsg } from "@/lib/api";

export default function Reconstitutions() {
  const [tab, setTab] = useState("pending");
  const [rows, setRows] = useState([]);
  const [bac, setBac] = useState(null);
  const [labelTarget, setLabelTarget] = useState(null);

  const load = useCallback(() => {
    api.get("/admin/reconstitutions", { params: { status: tab } }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
    api.get("/admin/settings").then((r) => setBac(r.data.bac_water_stock_ml));
  }, [tab]);
  useEffect(() => {
    load();
  }, [load]);

  const toggle = async (r, done) => {
    try {
      await api.post(`/admin/orders/${r.order_id}/recon`, { item_index: r.item_index, done });
      toast.success(done ? `${r.product_name} reconstituted · ${r.total_bac_ml} mL deducted` : "Undone · BAC water returned");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div>
      <PageHeader eyebrow="Lab" title="Reconstitution">
        <div className="rounded-md border border-border bg-card px-4 py-2 font-mono-data text-sm" data-testid="recon-bac-stock">
          BAC water <span className="text-sky-400">{bac ?? "—"} mL</span>
        </div>
      </PageHeader>
      <div className="mb-6 flex gap-2">
        {["pending", "done", "all"].map((t) => (
          <button key={t} onClick={() => setTab(t)} data-testid={`recon-tab-${t}`}
            className={`rounded-full border px-4 py-1.5 text-sm capitalize transition-colors ${tab === t ? "border-emerald-500 bg-emerald-500/10 text-emerald-300" : "border-border text-muted-foreground hover:text-foreground"}`}>{t}</button>
        ))}
      </div>
      <ReconTable rows={rows} onToggle={toggle} onLabel={(r) => setLabelTarget({ orderId: r.order_id, itemIndex: r.item_index })} />
      <LabelDialog target={labelTarget} onClose={() => setLabelTarget(null)} />
    </div>
  );
}
